import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import deleteImg from "../../../../../picture/delete.png";
import reloadImg from "../../../../../picture/timer-language.png";
import { useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import WarningModal from "../../WarningModal";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center" },
  smallCell: { width: "40px", textAlign: "center", cursor: "pointer" },
};

function RadnoMestoDokArhivirana({
  dokumenta,
  moveToVazeci,
  checkedRows,
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll,
  onRefresh,
}) {
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: "",
  });
  const [deleteData, setDeleteData] = useState({
    documentId: "",
    documentType: "",
  });
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);

  const { dictionary, baseUrl } = useGlobalContext();

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType },
    );
  };

  const handleCheckRow = (id) => {
    setCheckedRows(
      checkedRows.includes(id)
        ? checkedRows.filter((r) => r !== id)
        : [...checkedRows, id],
    );
  };

  const handleCheckAll = () => {
    setCheckedRows(isCheckedAll ? [] : dokumenta.map((z) => z.id));
    setIsCheckedAll((prev) => !prev);
  };

  const handleOpenDelete = (id) => {
    if (selectedField.documentId === id && selectedField.documentType) {
      const doc = dokumenta.find((d) => d.id === id);
      if (!doc[selectedField.documentType]) {
        setIsOpenWarningModal(true);
        return;
      }
      setDeleteData(selectedField);
      return;
    }
    setDeleteData({ documentId: id, documentType: "" });
  };

  const handleConfirmDelete = async () => {
    try {
      const payload = { id: deleteData.documentId };
      if (deleteData.documentType) payload.column = deleteData.documentType;

      const { data } = await axios.post(
        `${baseUrl}/workplaces/deleteDocument.php`,
        payload,
      );
      if (data.status === 200) {
        onRefresh();
        setDeleteData({ documentId: "", documentType: "" });
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handlePreview = (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    window.open(
      `${baseUrl.replace("/api", "")}/${relativePath}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleDownload = (doc) => {
    if (!selectedField.documentId || selectedField.documentId !== doc.id) {
      alert("Prvo odaberi verziju (kockicu) ovog dokumenta.");
      return;
    }
    const pathKey = `${selectedField.documentType}_path`;
    const relativePath = doc[pathKey];
    if (!relativePath) {
      alert("Ova verzija dokumenta nema fajl.");
      return;
    }
    window.open(
      `${baseUrl}/zaposleni/download_document.php?path=${encodeURIComponent(relativePath)}`,
      "_blank",
    );
  };

  const isDeleteOneVersion = deleteData.documentId && deleteData.documentType;

  return (
    <>
      <table style={{ width: "100%", marginTop: "30px" }}>
        <thead>
          <tr>
            <th style={styles.smallCell}>
              <input
                type="checkbox"
                checked={isCheckedAll}
                onChange={handleCheckAll}
                style={{ width: "30px" }}
              />
            </th>
            <th style={styles.smallCell}>
              <img src={wordImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={pdfImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={imageImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.smallCell}>
              <img src={scanImg} style={{ width: "30px" }} />
            </th>
            <th style={styles.cell}>{dictionary["arhiviranaDokumenta"]}</th>
            <th style={styles.cell}>{dictionary["dodato"]}</th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
            <th style={styles.smallCell}></th>
          </tr>
        </thead>
        <tbody>
          {dokumenta.map((dokument) => (
            <tr key={dokument.id}>
              <td style={styles.cell}>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(dokument.id)}
                  onChange={() => handleCheckRow(dokument.id)}
                  style={{ width: "30px" }}
                />
              </td>
              {["word", "pdf", "image", "scan"].map((type) => (
                <td
                  key={type}
                  onClick={() => handleSelectDocument(dokument.id, type)}
                  style={{
                    ...styles.smallCell,
                    border:
                      selectedField.documentId === dokument.id &&
                      selectedField.documentType === type
                        ? "2px solid black"
                        : "",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: dokument[type],
                      width: "25px",
                      height: "25px",
                      margin: "auto",
                    }}
                  />
                </td>
              ))}
              <td style={styles.cell}>{dokument.naziv}</td>
              <td style={styles.cell}>{dokument.datum}</td>
              <td
                style={styles.smallCell}
                onClick={() => handlePreview(dokument)}
              >
                <img src={visibleImg} style={{ width: "30px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleDownload(dokument)}
              >
                <img src={downloadImg} style={{ width: "25px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => handleOpenDelete(dokument.id)}
              >
                <img src={deleteImg} style={{ width: "25px" }} />
              </td>
              <td
                style={styles.smallCell}
                onClick={() => moveToVazeci(dokument)}
              >
                <img src={reloadImg} style={{ width: "25px" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {deleteData.documentId && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={
            isDeleteOneVersion
              ? `Da li ste sigurni da želite da obrišete ${deleteData.documentType} verziju dokumenta?`
              : dictionary["confirmDeleteDocumentAllVersions"]
          }
          handleCancel={() =>
            setDeleteData({ documentId: "", documentType: "" })
          }
        />
      )}

      {isOpenWarningModal && (
        <WarningModal
          text={dictionary["nepostojecaVerzija"]}
          handleCancel={() => setIsOpenWarningModal(false)}
        />
      )}
    </>
  );
}

export default RadnoMestoDokArhivirana;
